;(function() {
/* @ngInject */
function ZmenaSroKrok3Controller(ZmenaSroKrok3Service, UserService, BusinessSubjects, $scope, $window, Helpers, ModalFinishLater, routes, $filter) {
  let vm = this;
  let server = ZmenaSroKrok3Service;
  vm.server = server;

  let userService = UserService;

  vm.subjects = BusinessSubjects;

  vm.loadingSteps = false;
  vm.maxStep = 2;

  vm.onFinishClick = onFinishClick;
  vm.onSaveForLaterClick = onSaveForLaterClick;
  vm.onBackClick = onBackClick;
  vm.scrollTo = Helpers.scrollTo;
  vm.mergeStreetNo = Helpers.mergeStreetNo;
  vm.orderId = 0;

  vm.cart = {
    finalPrice: 0
  };
  vm.order = {};

  vm.inProgress = false;
  vm.requiredCheckbox = false;

  vm.agreements = {
    agrees: false,
    representation: true
  };

  vm.upsells = {};
  vm.user = {};
  // Zaokrúhľovanie je dočasne vypnuté z dôvodu novej legislatívy a platieb iba na účet Legalia.
  // vm.donation = 0;
  // vm.totalPriceWithoutDonation = 0;

  window.showSpinner(10);
  server.getOrder().then(onOrderLoad);
  server.getMaxStep().then( (ms) => { vm.maxStep = ms; window.hideSpinnerWhenAllResolved(); });
  server.getCartV2().then(onCartLoad);
  server.getInvoiceInfo().then(onInvoiceInfoLoad);
  server.getPlaceOfBusiness().then(onPlaceOfBusinessLoad);
  server.getSelectedSubjects().then(onSelectedSubjectsLoad);
  server.getCompanyName().then(onCompanyNameLoad);
  server.getOrderId().then((id) => { vm.orderId = id; window.hideSpinnerWhenAllResolved(); });
  server.getUpsell().then((upsell) => { vm.upsells = upsell; window.hideSpinnerWhenAllResolved(); });

  userService.getLoggedUser().then((user) => {vm.user = user; window.hideSpinnerWhenAllResolved()});

  $scope.$on('on-price-change', function(event, args) {
    server.getCartV2().then(onCartLoad);
  });

  function onSelectedSubjectsLoad(ss) {
    vm.addSubjects = ss ? ss.subjects : [];

    window.hideSpinnerWhenAllResolved();
  }

  function onCompanyNameLoad(cn) {
    vm.companyName = cn;
    window.hideSpinnerWhenAllResolved();
  }

  function onBackClick() {
    server.getStepBeforeSummary().then((previousStep) => {
      $window.location = previousStep;
    });
  }

  function onOrderLoad(c) {
    if(c) {
      vm.order = c;
      if(c.onlyEndUser)
        server.getEndUserPrice()
          .then(() => server.getCartV2())
          .then(onCartLoad);
      vm.removeSubjects = $filter('filter')(vm.order.removeSubjects, {'remove': true});
      vm.persons = {
        addExecutors: [],
        editExecutors: [],
        removeExecutors: [],
        addFounders: [],
        editFounders: [],
        addClerks: [],
        editClerks: [],
        removeClerks: []
      };

      vm.rpvsPersons = {
        add: [],
        edit: []
      };

      angular.forEach(vm.order.persons, function (person) {
        if(person.executor) {
          if(person.change.add) vm.persons.addExecutors.push(person);
          if(person.change.edit && person.newData) vm.persons.editExecutors.push(person);
          if(person.change.remove) vm.persons.removeExecutors.push(person);
        }
        if(person.founder) {
          if(person.change.add) vm.persons.addFounders.push(person);
          if(person.change.edit && person.newData) vm.persons.editFounders.push(person);
        }
        if(person.clerk) {
          if(person.change.add) vm.persons.addClerks.push(person);
          if(person.change.edit && person.newData) vm.persons.editClerks.push(person);
          if(person.change.removeClerk) vm.persons.removeClerks.push(person);
        }
      });

      angular.forEach(vm.order.rpvsPersons, function (person) {
        if(person.change.add) vm.rpvsPersons.add.push(person);
        if(person.change.edit && person.newData) vm.rpvsPersons.edit.push(person);
      });

      vm.loadingSteps = true;
    } else {
      server.getStringContent().then((data) => {
        if (data) {
          vm.order = JSON.parse(data).data;
        }
        vm.loadingSteps = true;
      });
    }

    window.hideSpinnerWhenAllResolved();
  }

  function onInvoiceInfoLoad(o) {
    if(o) {
      vm.invoice = o;
    } else {
      server.getStringContent().then((data) => {
        if (data) {
          vm.invoice = JSON.parse(data);
        }
      });
    }

    window.hideSpinnerWhenAllResolved();
  }

  function onCartLoad(c) {
    vm.cart = c;
    window.hideSpinnerWhenAllResolved();
  }

  function onFinishClick() {
    if(!vm.agreements.agrees) {
      vm.requiredCheckbox = true;
      vm.scrollTo("scroll_checkbox");
    } else {
      saveDataLayer();
      server.getStepAfterSummary({
        agrees: vm.agreements.agrees,
        requestsRepresentation: vm.agreements.representation
      }).then((nextStep) => {
        if (nextStep === "zapisovatel") {
          $window.location = nextStep;
        } else {
          finishOrder();
        }
      });
    }
  }

  function saveDataLayer() {
    let dataLayer = Helpers.getDataLayer(vm.orderId,
      vm.order.onlyEndUser ? 'kuv' : 'zmeny_sro',
      'sro', '', vm.user);

    $window.localStorage.setItem('dataLayer', JSON.stringify(dataLayer));
  }

  function finishOrder() {
    if (vm.inProgress) {
      return;
    }

    vm.inProgress = true;
    window.showSpinner(1);
    server.finish({
      agrees: vm.agreements.agrees,
      requestsRepresentation: vm.agreements.representation
    }).then(function (_ref) {
      var success = _ref.success;

      if (success) {
        $window.location = "objednane";
      } else {
        // TODO move backend error rendering into a shared Angular response layer.
      }
      vm.inProgress = false;
      window.hideSpinnerWhenAllResolved();
    }).catch(function () {
      // TODO move backend error rendering into a shared Angular response layer.
      vm.inProgress = false;
      window.hideSpinnerWhenAllResolved();
    });
  }

  function onSaveForLaterClick() {
    ModalFinishLater(server)
      .add(server)
      .result
      .then();
  }

  function onPlaceOfBusinessLoad(pb) {
    if (angular.isDefined(pb)) {
      if (pb.type === "own") {
        vm.placeOfBusiness = pb;
      }
      else if (pb.type === "firmaren") {
        vm.placeOfBusiness = { type: pb.type };
        vm.firmarenAddress = pb;
      }
    } else {
      server.getStringContent().then((data) => {
        if (data) {
          vm.placeOfBusiness = JSON.parse(data).placeOfBusiness;
          if (pb.type === "firmaren") {
            vm.placeOfBusiness = { type: JSON.parse(data).placeOfBusiness.type };
            vm.firmarenAddress = JSON.parse(data).placeOfBusiness;
          }
        }
      });
    }

    window.hideSpinnerWhenAllResolved();
  }
}

angular.module("firmaren")
  .controller("ZmenaSroKrok3Controller", ZmenaSroKrok3Controller);
}());
